import { pluginIsACoachItem } from 'bundles/coach-item/common/lib';
import useWidgetSession from 'bundles/item-widget/hooks/useWidgetSession';
import type { Item } from 'bundles/learner-progress/types/Item';

const useIsCoachItem = (computedItem: Item): boolean => {
  const { courseId, id } = computedItem;

  // @ts-expect-error ts-migrate(7009) FIXME: update ContentSummary type to include the 'ungradedWidget' typeName
  const isUngradedPlugin = computedItem.contentSummary.typeName === 'ungradedWidget';

  const widgetSession = useWidgetSession(courseId, id, !isUngradedPlugin);
  const { session } = widgetSession || {};

  return !!session && pluginIsACoachItem(session.iframeTitle);
};

export default useIsCoachItem;
